import { Link } from "shared/components/Link";
import Layout from "../../components/mainPage/Layout";
import { AppRoute } from "../../constants";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    Приложение для рабочего стола (Desktop)
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        SCADA NPT Expert Desktop представляет собой клиент для SCADA NPT Expert, который предоставляет пользователю интерфейс для взаимодействия с системой. Основные функции и задачи клиента SCADA NPT Expert включают:
                    </p>

                    <ul className="mb-4 description__list">
                        <li className="mb-1 description__number-li">Визуализация процессов.
                            Клиент SCADA NPT Expert отображает данные с оборудования (датчиков, контроллеров, устройств) в виде графиков, схем, диаграмм и других визуальных элементов. Это позволяет операторам легко отслеживать состояние системы.
                        </li>
                        <li className="mb-1 description__number-li">Управление оборудованием.
                            Через клиент SCADA NPT Expert операторы могут отправлять команды на управление устройствами, например, запускать или останавливать оборудование, изменять параметры работы.
                        </li>
                        <li className="mb-1 description__number-li">Сбор и анализ данных.
                            Клиент SCADA NPT Expert собирает данные с оборудования, сохраняет их в базах данных и предоставляет инструменты для анализа. Это помогает выявлять тенденции, находить проблемы и оптимизировать процессы.
                        </li>
                        <li className="mb-1 description__number-li">Оповещение о событиях.
                            Клиент SCADA NPT Expert отображает предупреждения и аварийные сигналы, если параметры выходят за установленные пределы. Это позволяет операторам быстро реагировать на нештатные ситуации.
                        </li>
                        <li className="mb-1 description__number-li">Отчетность.
                            Клиент SCADA NPT Expert предоставляет инструменты для создания отчетов на основе собранных данных, что полезно для анализа эффективности и планирования.
                        </li>
                    </ul>
                    <h5  >Примеры использования SCADA NPT Expert Desktop</h5>

                    <ul >
                        <li><b>В энергетике:</b> управление электросетями, мониторинг генерации и распределения энергии.</li>
                        <li><b>В водоснабжении:</b> контроль уровня воды, давления, качества.</li>
                        <li><b>В производстве:</b> управление конвейерами, станками, роботами.</li>
                        <li><b>В транспорте:</b> управление светофорами, мониторинг движения поездов.</li>
                    </ul>
                    <p>Клиент SCADA NPT Expert является ключевым инструментом для операторов и инженеров, обеспечивая удобный интерфейс и функциональность для эффективного управления сложными процессами.</p>



                    <p>
                        SCADA NPT Expert Desktop устанавливается на ПК или ноутбук под управлением операционной системы:
                    </p>
                    <ul>
                        <li className="mb-1 description__number-li">ОС Альт</li>
                        <li className="mb-1 description__number-li">ASTRA Linux</li>
                        <li className="mb-1 description__number-li">РЕД ОС</li>
                        <li className="mb-1 description__number-li">РОСА</li>
                        <li className="mb-1 description__number-li">ОСнова</li>
                        <li className="mb-1 description__number-li">Атлант</li>
                        <li className="mb-1 description__number-li">CentOS</li>
                        <li className="mb-1 description__number-li">Red Hat Linux</li>
                        <li className="mb-1 description__number-li">Windows 7/8/8.1/10/11 или новее</li>
                    </ul>
                    <p>
                        В случае резервированного сервера SCADA NPT Expert с помощью SCADA NPT Expert Desktop выполняется подключение к основному и резервному серверу.
                    </p>

                    <p> В версии Multimonitor SCADA NPT Expert Desktop поддерживается вывод информации на видеокуб,видеостену или на  <Link className="text-links" to={`/${AppRoute.MultimonitorApplication}`}>несколько объединенных экранов</Link> (4 и более)</p>

                </div>
            </div>
        </div>
    </Layout>
}